"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEEKLY = exports.STANDARD = exports.MONTHLY = exports.FIFTEEN_MINUTE = exports.DAILY = exports.CUMULATIVE = exports.ALL = void 0;
var DAILY = 'daily';
exports.DAILY = DAILY;
var WEEKLY = 'weekly';
exports.WEEKLY = WEEKLY;
var FIFTEEN_MINUTE = 'fifteenMinute';
exports.FIFTEEN_MINUTE = FIFTEEN_MINUTE;
var MONTHLY = 'monthly';
exports.MONTHLY = MONTHLY;
var ALL = 'all';
exports.ALL = ALL;
var CUMULATIVE = 'cumulative';
exports.CUMULATIVE = CUMULATIVE;
var STANDARD = 'standard';
exports.STANDARD = STANDARD;